import {
  Button,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
  Paper,
  useMediaQuery
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React, { Fragment, useEffect, useState } from 'react'
import {
  PickingRoute,
  SelectedZone,
  UserZone
} from '../../../interfaces/Picking/Picking'
import WarningIcon from '@mui/icons-material/Warning'
import HowToVoteIcon from '@mui/icons-material/HowToVote'
import { useStyles } from '../styles'
import { eTypePickingRoute } from '../../../enums/eTypePickingRoute'
import PickingTypeSelect from './PickingTypeSelect'
import { useApi } from '../../../hooks/useApi'
import { Loading } from '../../UI'
import { Status } from '../../../hooks/useFetchState'
import { ApiConfig } from '../../../config/api'
import axios from 'axios'
import { ZoneSelect } from './PickingSelectZone'
import CustomAlert from '../../_WMS/AlertMessage/AlertMessage'
import { useUser } from '../../../hooks/useUser'
import { WarehouseDDL } from '../../Almacen/UI/WarehouseDDL'
interface PickingStartProps {
  pickingRoute: PickingRoute | undefined
  handleFetchProduct: any
  handleGenerateRoute: any
  onChangeTypePickingRoute: (type: eTypePickingRoute) => void
  selectedPickingType: eTypePickingRoute
  selectedZoneId: number
  setSelectedZoneId: (id: number) => void
}

export const PickingStart: React.FC<PickingStartProps> = ({
  pickingRoute,
  handleFetchProduct,
  handleGenerateRoute,
  selectedPickingType,
  onChangeTypePickingRoute,
  selectedZoneId,
  setSelectedZoneId
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')) // true si está en celular

  const {
    userDataState: { userData },
    getUserData
  } = useUser()

  const [isEditingZone, setIsEditingZone] = useState(false)
  const [selectedWarehouseId, setSelectedWarehouseId] = useState<number>(-1)
  const { state, callApi } = useApi<UserZone[]>()

  const getUserZone = (userId: number) => {
    const url = new URL(`${ApiConfig.UserAdminApi}/${userId}/zones`)

    return axios.get(url.toString())
  }

  const PrefixNameStorage: string = 'userSelectedZone_'

  useEffect(() => {
    if (!userData) {
      getUserData()
    }
  }, [])

  const requestGetUserZone = () => {
    callApi(getUserZone(userData?.userId || (0 as number)))
      .then((data) => {
        const zones = data as UserZone[]
        const key = `${PrefixNameStorage}${userData?.userId || 0}`
        const storedZoneJson = localStorage.getItem(key)

        let initialZoneId = zones[0].zoneId
        let initialWarehouseId = zones[0].warehouseId

        if (storedZoneJson) {
          try {
            const parsed: SelectedZone = JSON.parse(storedZoneJson)
            const existsInList = zones.some(z => z.zoneId === parsed.selectedZoneId)
            if (existsInList) {
              initialZoneId = parsed.selectedZoneId
              initialWarehouseId = zones.find(z => z.zoneId === parsed.selectedZoneId)!.warehouseId
            }
          } catch {
            // usa defaults
          }
        }

        setSelectedWarehouseId(initialWarehouseId)
        setSelectedZoneId(initialZoneId)
      })
      .catch()
  }

  const warehouses = React.useMemo(() => {
    if (!state.data) return []
    const map = new Map<number, { warehouseId: number; warehouseName: string }>()
    state.data.forEach(z => {
      if (!map.has(z.warehouseId)) map.set(z.warehouseId, { warehouseId: z.warehouseId, warehouseName: z.warehouseName })
    })
    return Array.from(map.values())
  }, [state.data])

  const filteredZones = React.useMemo(
    () => (state.data || []).filter(z => z.warehouseId === selectedWarehouseId),
    [state.data, selectedWarehouseId]
  )

  useEffect(() => {
    requestGetUserZone()
  }, [])

  if (state.status === Status.Loading) {
    return (
      <div>
        <Typography>
          <Loading />
        </Typography>
      </div>
    )
  } else {
    return (
      <Grid
        container
        direction='column'
        justifyContent='flex-start'
        alignItems='center'
        spacing={2}
      >
        {' '}
        {!pickingRoute && (
          <Grid item xs={11} sm={6} md={4} style={{ width: isMobile ? '100%' : '50%' }}>
            <PickingTypeSelect
              selectedType={selectedPickingType}
              onChange={(value) => onChangeTypePickingRoute(value)}
            />
          </Grid>
        )}
        {!state.data ? (
          <CustomAlert
            severity='warning'
            message={state.error}
            maxWidth={'50%'}
          ></CustomAlert>
        ) : (
          <Fragment>
            <Grid item xs={11} sm={6} md={4} style={{ width: isMobile ? '100%' : '50%' }}>
              <WarehouseDDL
                label='Bodega'
                fullWidth
                type='outlined'
                value={selectedWarehouseId}
                disabled={warehouses.length <= 1}
                allowedIds={warehouses.map(w => w.warehouseId)}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const newWhId = Number(e.target.value)
                  setSelectedWarehouseId(newWhId)
                  const firstZone = (state.data || []).find(z => z.warehouseId === newWhId)
                  if (firstZone) setSelectedZoneId(firstZone.zoneId)
                }}
              />
            </Grid>
            <ZoneSelect
              zones={filteredZones}
              isEditingZone={isEditingZone}
              userId={userData?.userId || 0}
              prefixNameStorage={PrefixNameStorage}
              selectedZoneId={selectedZoneId}
              setSelectedZoneId={setSelectedZoneId}
              setIsEditingZone={setIsEditingZone}
              isMobile={isMobile}
              canChangeZone={filteredZones.length > 1}
            />
            <Grid container justifyContent='center' style={{ width: '100%' }}>
              <Grid
                item
                xs={11}
                sm={6}
                md={4}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: 15
                }}
              >
                {pickingRoute ? (
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={handleFetchProduct}
                    disabled={isEditingZone}
                    fullWidth={isMobile}
                    style={{ minHeight: 40,
                      width: isMobile ? '100%' : '250px'
                     }}
                  >
                    Continuar picking
                  </Button>
                ) : (
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={handleGenerateRoute}
                    disabled={isEditingZone}
                    fullWidth={isMobile}
                    style={{ minHeight: 40, fontSize: isMobile ? '1.1rem' : '1rem', width: isMobile ? '100%' : '250px' }}
                  >
                    Iniciar nuevo picking
                  </Button>
                )}
              </Grid>
            </Grid>
          </Fragment>
        )}
        {!pickingRoute && (
          <Grid item xs={12} style={{ marginTop: 60 }}>
            <Paper elevation={0} className={classes.paper}>
              <List className={classes.alert}>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <WarningIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary='No hay rutas de picking asignadas'
                    secondary=''
                  />
                </ListItem>
              </List>
            </Paper>
          </Grid>
        )}
        {pickingRoute && (
          <Grid item xs={12}>
            <Paper elevation={0} className={classes.paper}>
              <List className={classes.alert}>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <HowToVoteIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={'Ruta de Picking'}
                    secondary={
                      pickingRoute.typePickingRouteId === eTypePickingRoute.RTV
                        ? `#RTV${pickingRoute.pickingRouteId}`
                        : `#${pickingRoute.pickingRouteId}`
                    }
                  />
                </ListItem>
              </List>
            </Paper>
          </Grid>
        )}        
      </Grid>
    )
  }
}
